import { __awaiter } from "tslib";
import axios from 'axios';
import VueAxios from 'vue-axios';
import msalWrapperClass from './SSOService';
/**
 * @description service to call HTTP request via Axios
 */
class ApiService {
    /**
     * @description initialize vue axios
     */
    static init(app) {
        ApiService.vueInstance = app;
        ApiService.vueInstance.use(VueAxios, axios);
    }
    /**
     * @description set the default HTTP request headers
     */
    static setHeader() {
        return __awaiter(this, void 0, void 0, function* () {
            // always request token from msal
            const wrapper = msalWrapperClass.getInstance();
            const msal = msalWrapperClass.getMSALInstance();
            const account = JSON.parse(localStorage.getItem('account-info-cache'));
            const accessToken = yield wrapper.getAccessToken(msal, account);
            const contentLanguage = localStorage.getItem('lang')
                ? localStorage.getItem('lang')
                : 'en';
            ApiService.vueInstance.axios.defaults.headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                'Content-Language': contentLanguage
            };
            ApiService.vueInstance.axios.defaults.responseType = 'json';
            Promise.resolve();
        });
    }
    static setHeaderCustomBearer(customBearer) {
        return __awaiter(this, void 0, void 0, function* () {
            // always request token from msal
            const contentLanguage = localStorage.getItem('lang')
                ? localStorage.getItem('lang')
                : 'en';
            ApiService.vueInstance.axios.defaults.headers = {
                Authorization: `Bearer ` + customBearer,
                'Content-Type': 'application/json',
                'Content-Language': contentLanguage
            };
            ApiService.vueInstance.axios.defaults.responseType = 'json';
        });
    }
    static setHeaderXTOKEN(workflowToken) {
        return __awaiter(this, void 0, void 0, function* () {
            // always request token from msal
            const wrapper = msalWrapperClass.getInstance();
            const msal = msalWrapperClass.getMSALInstance();
            const account = JSON.parse(localStorage.getItem('account-info-cache'));
            const accessToken = yield wrapper.getAccessToken(msal, account);
            const contentLanguage = localStorage.getItem('lang')
                ? localStorage.getItem('lang')
                : 'en';
            ApiService.vueInstance.axios.defaults.headers = {
                Authorization: `Bearer ${accessToken}`,
                'X-TOKEN': '0;0;0;' + workflowToken,
                'Content-Type': 'application/json',
                'Content-Language': contentLanguage
            };
            ApiService.vueInstance.axios.defaults.responseType = 'json';
        });
    }
    static setHeaderWorkflow(usrName, pwd) {
        return __awaiter(this, void 0, void 0, function* () {
            // always request token from msal
            const contentLanguage = localStorage.getItem('lang')
                ? localStorage.getItem('lang')
                : 'en';
            ApiService.vueInstance.axios.defaults.headers = {
                Authorization: 'Basic ' + btoa(usrName + ':' + pwd),
                'Content-Type': 'application/x-www-form-urlencoded',
                'Content-Language': contentLanguage
            };
            ApiService.vueInstance.axios.defaults.responseType = 'json';
        });
    }
    static setHeaderBlobFile() {
        return __awaiter(this, void 0, void 0, function* () {
            // always request token from msal
            const wrapper = msalWrapperClass.getInstance();
            const msal = msalWrapperClass.getMSALInstance();
            const account = JSON.parse(localStorage.getItem('account-info-cache'));
            const accessToken = yield wrapper.getAccessToken(msal, account);
            const contentLanguage = localStorage.getItem('lang')
                ? localStorage.getItem('lang')
                : 'en';
            ApiService.vueInstance.axios.defaults.headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Language': contentLanguage
                // "Content-Type": undefined,
            };
            ApiService.vueInstance.axios.defaults.responseType = 'arraybuffer';
        });
    }
    static setHeaderUpload() {
        return __awaiter(this, void 0, void 0, function* () {
            // always request token from msal
            const wrapper = msalWrapperClass.getInstance();
            const msal = msalWrapperClass.getMSALInstance();
            const account = JSON.parse(localStorage.getItem('account-info-cache'));
            const accessToken = yield wrapper.getAccessToken(msal, account);
            const contentLanguage = localStorage.getItem('lang')
                ? localStorage.getItem('lang')
                : 'en';
            ApiService.vueInstance.axios.defaults.headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data; boundary=',
                'Content-Language': contentLanguage
                // "Content-Type": undefined,
            };
            ApiService.vueInstance.axios.defaults.responseType = 'json';
        });
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static query(resource, params) {
        ApiService.setHeader();
        return ApiService.vueInstance.axios.get(resource, params).catch((error) => {
            throw new Error(`[KT] ApiService ${error}`);
        });
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static get(resource, slug = '', param = '') {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeader();
            param = param ? `?${param}` : '';
            let url = `${resource}/${slug}${param}`;
            if (url[url.length - 1] == '/') {
                url = url.substring(0, url.length - 1);
            }
            return ApiService.vueInstance.axios.get(url);
        });
    }
    static getData(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeader();
            return ApiService.vueInstance.axios.get(resource);
        });
    }
    static getWithXToken(resource, workflowToken) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeaderXTOKEN(workflowToken);
            return ApiService.vueInstance.axios.get(resource);
        });
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static getBlob(resource, slug = '', param = '') {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeader();
            yield ApiService.setHeaderBlobFile();
            param = param ? `?${param}` : '';
            let url = `${resource}/${slug}${param}`;
            if (url[url.length - 1] == '/') {
                url = url.substring(0, url.length - 1);
            }
            return ApiService.vueInstance.axios.get(url);
        });
    }
    /**
     * @description set the POST HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static post(resource, params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeader();
            return ApiService.vueInstance.axios.post(`${resource}`, params);
        });
    }
    static postWithXToken(resource, params, workflowToken) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeaderXTOKEN(workflowToken);
            return ApiService.vueInstance.axios.post(`${resource}`, params);
        });
    }
    static postCustomBearer(resource, params, customBearer) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeaderCustomBearer(customBearer);
            return ApiService.vueInstance.axios.post(`${resource}`, params);
        });
    }
    static postWorkflow(resource, params, usrName, pwd) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeaderWorkflow(usrName, pwd);
            return ApiService.vueInstance.axios.post(`${resource}`, params);
        });
    }
    static postImages(resource, params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeaderUpload();
            return ApiService.vueInstance.axios.post(`${resource}`, params);
        });
    }
    static postBlobFile(resource, params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeaderBlobFile();
            return ApiService.vueInstance.axios.post(`${resource}`, params);
        });
    }
    static patch(resource, params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeader();
            return ApiService.vueInstance.axios.patch(`${resource}`, params);
        });
    }
    /**
     * @description send the UPDATE HTTP request
     * @param resource: string
     * @param slug: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static update(resource, slug, params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeader();
            return ApiService.vueInstance.axios.put(`${resource}/${slug}`, params);
        });
    }
    /**
     * @description Send the PUT HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static put(resource, params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeader();
            return ApiService.vueInstance.axios.put(`${resource}`, params);
        });
    }
    static putWithXTOKEN(resource, params, workflowToken) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeaderXTOKEN(workflowToken);
            return ApiService.vueInstance.axios.put(`${resource}`, params);
        });
    }
    /**
     * @description Send the DELETE HTTP request
     * @param resource: string
     * @returns Promise<AxiosResponse>
     */
    static delete(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ApiService.setHeader();
            return ApiService.vueInstance.axios.delete(resource).catch((error) => {
                throw new Error(`[RWV] ApiService ${error}`);
            });
        });
    }
}
export default ApiService;
